import { render, staticRenderFns } from "./ticketInfo.vue?vue&type=template&id=4a1dafc4&scoped=true"
import script from "./ticketInfo.vue?vue&type=script&lang=js"
export * from "./ticketInfo.vue?vue&type=script&lang=js"
import style0 from "./ticketInfo.vue?vue&type=style&index=0&id=4a1dafc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1dafc4",
  null
  
)

export default component.exports